import { colors, devices, font } from '../../config/theme'

const style = {}

style.base = {}

style.base[devices.desktop] = {
  '& .payment-container': {
    margin: '0'
  },
  '& .ccExpiry': {
    width: '50% !important'
  },
  '& .ccCVC': {
    width: '35% !important'
  },
  '& input': {
    marginTop: '42px !important'
  }
}

style.base[devices.mobile] = {
  '& .payment-container': {
    marginTop: '40px',
    width: '100%'
  },
  '& .ccExpiry': {
    width: '50% !important'
  },
  '& .ccCVC': {
    width: '40% !important'
  },
  '& input': {
    marginTop: '12px !important'
  }
}

export default style
